// src/api/joinCodeApi.js
// Wraps the Spring backend's /joincode endpoint (com.experience.joincode.JoinCodeController).
import axiosClient from "./axiosClient";

// Returns { code, teamId, organizationId, leadUid }, or null if the code doesn't exist.
export const getJoinCodeByCode = async (code) => {
  try {
    const response = await axiosClient.get("/joincode", { params: { code } });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

// Returns the join code string for a team, or null if it has none.
export const getJoinCodeByTeamId = async (teamId) => {
  try {
    const response = await axiosClient.get("/joincode/byteam", { params: { teamId } });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};
